import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useDomain } from './hooks';
import DomainDisconnect from './DomainDisconnect';
import DomainEdit from './DomainEdit';
import ChangeDNS from './ChangeDNS';

export default function Domain() {
    const domain = useDomain();

    let step;

    if (domain.name && domain.resolved) {
        step = 'disconnect';
    } else if (domain.name && !domain.resolved) {
        step = 'change-dns';
    } else {
        step = 'edit';
    }

    return (
        <Switch>
            <Route exact path="/p/settings/url/domain/edit" component={DomainEdit} />
            <Route exact path="/p/settings/url/domain/change-dns" component={ChangeDNS} />
            <Route exact path="/p/settings/url/domain/disconnect" component={DomainDisconnect} />
            <Redirect to={`/p/settings/url/domain/${step}`} />
        </Switch>
    );
}
